import React from 'react';
import { IndexRedirect, IndexRoute, Redirect, Route } from 'react-router';

import GroupPage from 'pages/groups/GroupPage';
import RouteNames from 'pages/groups/routeNames';

import loadOnRoute from 'bundles/common/components/loadOnRoute';

const NotFound = loadOnRoute(() => import('bundles/phoenix/components/NotFound'));

const GroupAppContainer = loadOnRoute(() => import('bundles/groups/components/GroupAppContainer'));
const MemberTool = loadOnRoute(() => import('bundles/groups/components/MemberTool'));

const GroupExportTool = loadOnRoute(() => import('bundles/groups/components/GroupExportTool'));
const GroupSettingsTool = loadOnRoute(() => import('bundles/groups/components/GroupSettingsTool'));
const GroupInvitationTool = loadOnRoute(() => import('bundles/groups-invitation/components/GroupInvitationTool'));
const GroupAnnouncementTool = loadOnRoute(() => import('bundles/groups/components/GroupAnnouncementTool'));

const GroupRoutes = (
  <Route path="/groups" component={GroupPage}>
    <Route // DEPRECATED
      path=":groupSlug/courses/:courseSlug/acceptGroupInvitation"
      name={RouteNames.COURSE_ACCEPT_INVITATION}
      getComponent={GroupInvitationTool}
    />

    <Route path=":groupSlug/invitation" name={RouteNames.GROUP_PERMALINK} getComponent={GroupInvitationTool} />

    <Route
      path=":groupSlug/acceptGroupInvitation"
      name={RouteNames.ACCEPT_INVITATION}
      getComponent={GroupInvitationTool}
    />

    <Route path=":groupSlug" getComponent={GroupAppContainer}>
      <Route path="members" name={RouteNames.GROUP_MEMBERS}>
        <IndexRoute getComponent={MemberTool} />
        <Route path="invitation" name={RouteNames.GROUP_MEMBERS_INVITATION} getComponent={MemberTool} />
      </Route>

      <Route path="exports" name={RouteNames.GROUP_EXPORTS} getComponent={GroupExportTool} />

      <Route path="settings" name={RouteNames.GROUP_SETTINGS} getComponent={GroupSettingsTool} />

      <Route // DEPRECATED
        path="specializations/:s12nSlug/acceptGroupInvitation"
        name={RouteNames.S12N_ACCEPT_INVITATION}
        getComponent={GroupInvitationTool}
      />

      <Route path="announcements" name={RouteNames.GROUP_ANNOUNCEMENTS} getComponent={GroupAnnouncementTool} />

      <IndexRedirect to="members" />
      <Redirect from="dashboard(/)*" to="members" />
    </Route>

    <Route path="*" getComponent={NotFound} />
  </Route>
);

export default GroupRoutes;
